import Localization from "../localization";
import api from "./api";

const alarmRecipients = (
  uuid,
  params = {
    limit: 5,
    offset: 0,
  }
) =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await api.get(`rest/devices/${uuid}/alarmrecipients`, {
        params,
      });
      resolve(res);
    } catch (error) {
      reject({ error });
    }
  });

const addAlarmRecipient = (uuid, data) =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await api.post(`/rest/devices/${uuid}/alarmrecipients`, {
        data,
      });
      resolve(res);
    } catch (error) {
      reject({ error });
    }
  });

const updateAlarmRecipient = (uuid, { id, ...data } = {}) =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await api.put(`/rest/devices/${uuid}/alarmrecipients/${id}`, {
        data,
      });
      resolve(res);
    } catch (error) {
      reject({ error });
    }
  });

const removeAlarmRecipient = (uuid, { id } = {}) =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await api.delete(
        `/rest/devices/${uuid}/alarmrecipients/${id}`
      );
      resolve(res);
    } catch (error) {
      reject({ error });
    }
  });

const updateAlarmRecipientCategories = async (uuid, data = []) => {
  await api.put(`/rest/devices/${uuid}/alarmrecipients/categories`, { data });
};

const types = async (params = {}) => {
  const lang = Localization.getLanguage();
  params.lang = lang;
  const data = await api.get(`/rest/devices/types`, { params });
  return data;
};

const type = async (uuid, params = {}) => {
  const lang = Localization.getLanguage();
  params.lang = lang;
  const data = await api.get(`/rest/devices/types`, { params });
  return data.flat().find((type) => type.uuid === uuid);
};

export default {
  type,
  types,
  alarmRecipients,
  addAlarmRecipient,
  removeAlarmRecipient,
  updateAlarmRecipient,
  updateAlarmRecipientCategories,
};
